import { render, staticRenderFns } from "./OutputInvoice.vue?vue&type=template&id=2ca452c4&scoped=true"
import script from "./OutputInvoice.vue?vue&type=script&lang=js"
export * from "./OutputInvoice.vue?vue&type=script&lang=js"
import style0 from "./OutputInvoice.vue?vue&type=style&index=0&id=2ca452c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca452c4",
  null
  
)

export default component.exports